import { Customer } from "types/customer";
import { Quotation } from "types/quotation";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "contexts/LanguageContext";
import { isQuotation } from "./DocumentGeneratorModal";

interface SelectedDocumentProps {
  documentDataProvider: Quotation | Customer | null;
}

const SelectedDocument = ({ documentDataProvider }: SelectedDocumentProps) => {
  const { t } = useLanguage();

  if (!documentDataProvider) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <DocumentTextIcon className="h-12 w-12 text-gray-500 mb-4" />
        <p className="text-gray-400 text-sm text-center">
          {t('documents.selectDocument')}
        </p>
      </div>
    );
  }
  return (
    <div className="bg-white pb-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">
        {t('documents.selectedDocument', { type: isQuotation(documentDataProvider) ? t('documents.quotation') : t('documents.customer') })}
      </h3>
      <div className="flex items-center">
        <div className="p-1.5 rounded bg-gradient-to-br from-teal-100 to-teal-200 border-teal-200 border mr-2">
          <DocumentTextIcon className="h-5 w-5 text-teal-600" />
        </div>
        <div>
          <div className="text-sm font-medium text-gray-800">
            {isQuotation(documentDataProvider)
              ? documentDataProvider.companyName || documentDataProvider.quotationNumber
              : documentDataProvider.type === 'organization'
                ? documentDataProvider.companyName
                : `${documentDataProvider.firstName} ${documentDataProvider.lastName}`
            }
          </div>
          <div className="text-xs text-gray-500">
            {isQuotation(documentDataProvider)
              ? documentDataProvider.quotationNumber
              : documentDataProvider.type === 'organization'
                ? documentDataProvider.taxNumber
                : documentDataProvider.email
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectedDocument;